module.exports = __webpack_public_path__ + "img/iPhone.2958caa7.png";